<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                
                <div class="row paddingku2">
                    <div class="col-md-3 ">
                        <span class="h_page">Validasi Surat</span> <br> <br>
                    </div>
                    <div class="col-md-6 ">
                        <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                    </div>
                    <div class="col-md-3">
                        <select v-model="filter_data" @change="getView()" class="form-control" >
                            
                            <option value="">Tampil Semua Data</option> 
                            <option value="proses" selected>Proses</option>
                            <option value="diterima">Diterima</option>
                            <option value="dikembalikan">Dikembalikan</option>
                        </select>
                        <br>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th style="width: 20%">Nomor</th>
                            <th class="text-center" style="width: 10%">Status TTD</th>
                            <!-- <th style="width: 27%">Status</th> -->
                            <th style="width: 37%">Judul</th>
                            <th class="text-center" style="width: 10%">Tgl</th>
                            <th style="width: 18%"></th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                              <td class="text-center">{{index+1}}.</td>
                              <td>{{data.nomor}}</td>
                              <td class="text-center">{{cek_ttd(data.status_ttd)}}</td>
                              <!-- <td>{{data.status}}</td> -->
                              <td>{{data.judul}}</td>
                              <td class="text-center">{{timeSplit(data.tgl)}}</td>
                              <td class="text-center" >
                                <button @click="SelectData(data)" class="btn bg-blue btn-xs waves-effect" title="Lihat Detil Surat" data-toggle="modal" data-target="#m_lihat_surat">
                                    <i class="material-icons" >find_in_page</i>
                                </button>
                                &nbsp;
                                <button @click="SelectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Validasi Surat" data-toggle="modal" data-target="#m_validasi_data">
                                    <i class="material-icons" >check</i>
                                </button>
                                &nbsp;
                                <button @click="SelectData(data)" class="btn bg-red btn-xs waves-effect" title="Kembalikan Konsep Surat" data-toggle="modal" data-target="#m_kembalikan_data">
                                    <i class="material-icons" >clear</i>
                                </button>   
                              </td>
                          </tr>
                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KEMBALIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_kembalikan_data" role="dialog" data-keyboard="false" data-backdrop="static">
                            <div class="modal-dialog modal-md" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-red">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">MEMO PENGEMBALIAN</h4>
                                    </div>
                                    <div class="modal-body">
                                        <div>
                                            <span class="h_title">Memo Pengembalian</span> <br>
                                            <textarea class="form-control" v-model="form.keterangan" ></textarea>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button @click="kembalikanData()" type="button" class="btn btn-warning waves-effect">KEMBALIKAN</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">BATAL</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KEMBALIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_lihat_surat" role="dialog"  data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-blue">
                                        <button @click="emptyData()"  type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>
                                    <div class="modal-body">

                                        <div class="table-responsive">
                                            <table class="h_isitable" style="width: 100%">
                                                <tr>
                                                    <td style="width: 19%; padding-left:2%">Konseptor</td>
                                                    <td style="width: 1%; padding-left:2%">:</td>
                                                    <td style="width: 80%; padding-left:2%">Hikmah Langgahi Tama</td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 19%; padding-left:2%">Pemeriksa</td>
                                                    <td style="width: 1%; padding-left:2%">:</td>
                                                    <td style="width: 80%; padding-left:2%">
                                                        {{form.pemeriksa_gelar_depan}} {{form.pemeriksa_nama}} {{form.pemeriksa_gelar_belakang}}
                                                        &nbsp;
                                                        <span v-if="form.status != 'proses' ">
                                                            ({{timeSplit(form.tgl_validasi)}})

                                                            <i v-if="form.status == 'diterima'" class="material-icons" style="color:green">check</i>
                                                            <i v-if="form.status == 'dikembalikan'" class="material-icons" style="color:red">clear</i>
                                                        </span>
                                                        
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 19%; padding-left:2%">Penanda Tangan</td>
                                                    <td style="width: 1%; padding-left:2%">:</td>
                                                    <td style="width: 80%; padding-left:2%">
                                                        {{form.penanda_tangan_gelar_depan}} {{form.penanda_tangan_nama}} {{form.penanda_tangan_gelar_belakang}}
                                                        &nbsp;
                                                        <span v-if="form.status_ttd">
                                                            ({{timeSplit(form.tgl_validasi)}})
                                                            <i class="material-icons" style="color:green">check</i>
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 19%; padding-left:2%">Status</td>
                                                    <td style="width: 1%; padding-left:2%">:</td>
                                                    <td style="width: 80%; padding-left:2%">{{form.keterangan}}</td>
                                                </tr>
                                                
                                            </table>
                                            <hr>
                                            <span>
                                                <div v-html="form.isi"></div>
                                            </span>
                                            <hr>
                                            <button type="button" class="btn btn-default" data-toggle="modal" data-target="#m_lampiran_surat">
                                                LAMPIRAN
                                                <i class="material-icons">attachment</i>
                                            </button>
                                        </div>



                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-info waves-effect">CETAK</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LAMPIRAN SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_lampiran_surat" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-blue">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">LAMPIRAN SURAT</h4>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row text-center">
                                            <embed :src="form.file_tampil" width="100%" height="2100px" />
                                            <!-- <iframe v-bind:src="'https://docs.google.com/gview?url='+file_tampil+'&embedded=true'" style="width: 100%;height: 2100px;border: none;" frameborder="0"></iframe> -->
                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LAMPIRAN SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST PENERIMA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_validasi_data" role="dialog" data-keyboard="false" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">LIST PENERIMA</h4>
                                    </div>
                                    <div class="modal-body">
                                        <div>
                                            <button @click="getUnit_kerja()" class="btn bg-light-green btn-block waves-effect" data-toggle="modal" data-target="#m_unit_kerja">
                                                PILIH PENERIMA
                                            </button> 
                                            <hr>
                                            <div class="table-responsive">
                                            <table class="table-bordered table-striped" style="width: 100%">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 5%">No</th>
                                                        <th style="width: 90%">Instansi</th>
                                                        <th style="width: 5%"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(data, index) in list_penerima" :key="data.surat_penerima_id">
                                                        <td>{{index+1}}</td>
                                                        <td>{{data.unit_kerja_nama}}</td>
                                                        <td class="text-center">
                                                            <button @click="removePenerima(data.surat_penerima_id)" class="btn bg-red btn-xs waves-effect" title="Kembalikan Konsep Surat" data-toggle="modal" data-target="#m_kembalikan_data">
                                                                <i class="material-icons" >clear</i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button @click="validasiData" type="button" class="btn btn-info waves-effect">VALIDASI</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST PENERIMA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL PILIH UNIT KERJA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_unit_kerja" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-blue">
                                        <button  @click="emptyDataUnit_Kerja()" type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">PENERIMA SURAT</h4>
                                    </div>
                                    <div class="modal-body">
                                        <!-- <span>Checked names: {{ list_unit_kerja | json }}</span> -->
                                        <input type="text" class="form-control" placeholder="Cari Unit Kerja" @keyup="filter_unit_kerja" v-model="cari_unit_kerja"> <hr>
                                        <div class="table-responsive">
                                            <table class="table-bordered table-striped" style="width: 100%">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 5%">No</th>
                                                        <th style="width: 90%">Instansi</th>
                                                        <th style="width: 5%">Pilih</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(data, index) in pilih_unit_kerja" :key="data.id">
                                                        <td>{{index+1}}</td>
                                                        <td>{{data.unit_kerja}}</td>
                                                        <td class="text-center">
                                                            <input type="checkbox" :id="data.id" class="filled-in" :value="data.id" v-model="list_unit_kerja"> 
                                                            <label :for="data.id"></label>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        

                                        <hr>
                                            <div class="text-center">
                                                <button @click="btn_prev1" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                                    <i class="material-icons">skip_previous</i>
                                                </button>
                                                &nbsp;
                                                <span style="font-size: 85%; color: #a5a5a5">
                                                    <b>{{page_first1}} - {{page_last1}}</b>
                                                </span>
                                                &nbsp;
                                                <button @click="btn_next1" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                                    <i class="material-icons">skip_next</i>
                                                </button>
                                            </div>
                                        <hr>



                                    </div>
                                    <div class="modal-footer">
                                        <button @click="tambahPenerima" type="button" class="btn btn-info waves-effect">TAMBAH</button>
                                        <button @click="emptyDataUnit_Kerja()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL PILIH UNIT KERJA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/office_surat_validasi/';
    const UNIT_URL = URL_APP+'api/v1/simpeg_unit_kerja/';
    const FILE_LOAD = URL_APP+'uploads/';
    const UNIT_KERJA = URL_APP+'api/v1/simpeg_unit_kerja/';


    export default {
    name: "monev_kabupaten",
    data() {
        return {

            form : {
                id : '',
                isi : '',
                jenis : 'Elektronik',
                judul : '',
                keterangan : '',
                konseptor : '',

                lampiran : '',
                lampiran_type : '',
                nomor : '',
                pemeriksa : '',
                pemeriksa_gelar_belakang : '',
                pemeriksa_gelar_depan : '',
                pemeriksa_gol : '',
                pemeriksa_id : '',
                pemeriksa_jabatan : '',
                pemeriksa_nama : '',

                penanda_tangan : '',
                penanda_tangan_gelar_belakang : '',
                penanda_tangan_gelar_depan : '',
                penanda_tangan_gol : '',
                penanda_tangan_id : '',
                penanda_tangan_jabatan : '',
                penanda_tangan_nama : '',
                file_tampil : '',
                unit_kerja : '',
                instansi_id : '',
                status_ttd : 0,
                tgl : '',
                tgl_validasi : '',
                tgl_ttd : '',
                tgl_agenda : '',

            },
           

            perihal : '',
            sifat : 'Biasa',
            status : '',
            tgl : '',
            type : 'Permohonan',


            unit_kerja : '',
            unit_kerja_full : '',
            instansi_id : '',

            fileku : null,

            list_unit_kerja : [],
            pilih_unit_kerja : [],

            list_penerima: [],

            list_data: [],

            page_first: 1,
            page_last: 0,
            cari_value: "",
            cari_unit_kerja: "",
            filter_data: "proses",
            


            page_first1: 1,
            page_last1: 0,
        };
    },

    // =============================================================== METHODS =========================================================================
    methods : {
        onFileSelected : function(event){
            this.fileku = event.target.files[0];
        },
        getView: function() {
            fetch(ADD_URL + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    data_ke: this.page_first,
                    cari_value: this.cari_value,
                    filter_data: this.filter_data
                })
            })
                .then(res => res.json())
                .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                console.log(res_data);
            });
        },

        validasiData : function(){
            if (this.list_penerima.length <= 0) {
                alert('PILIH PENERIMA TERLEBIH DAHULU...!!')
            } else {
                fetch (ADD_URL+'surat_validasi', {
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    id: this.form.id,
                    surat_penerima : this.list_penerima
                })
                }).then((res_data)=>{
                    this.alertku("success", "sukses validasi data");
                    this.getView();
                });
            }
        },
        kembalikanData : function(id){
            fetch(ADD_URL+'validasi_kembalikan', {
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization : 'kikensbatara '+ localStorage.token
                },
                body : JSON.stringify({
                    id: this.form.id,
                    keterangan: this.form.keterangan,
                })
            }).then((res_data)=>{
                this.getView();
                this.alertku("success", "Surat dikembalikan");
            })
        },
        SelectData : function(data){
            console.log(data);
            this.form = {
                id : data.id,
                isi : data.isi,
                judul : data.judul,
                keterangan : data.keterangan,
                konseptor : data.konseptor,

                lampiran : data.lampiran,
                lampiran_type : data.lampiran_type,
                nomor : data.nomor,
                pemeriksa : data.pemeriksa,
                pemeriksa_gelar_belakang : data.pemeriksa_gelar_belakang,
                pemeriksa_gelar_depan : data.pemeriksa_gelar_depan,
                pemeriksa_gol : data.pemeriksa_gol,
                pemeriksa_id : data.pemeriksa_id,
                pemeriksa_jabatan : data.pemeriksa_jabatan,
                pemeriksa_nama : data.pemeriksa_nama,

                penanda_tangan : data.penanda_tangan,
                penanda_tangan_gelar_belakang : data.penanda_tangan_gelar_belakang,
                penanda_tangan_gelar_depan : data.penanda_tangan_gelar_depan,
                penanda_tangan_gol : data.penanda_tangan_gol,
                penanda_tangan_id : data.penanda_tangan_id,
                penanda_tangan_jabatan : data.penanda_tangan_jabatan,
                penanda_tangan_nama : data.penanda_tangan_nama,
                file_tampil : FILE_LOAD+''+data.lampiran,
                unit_kerja : data.unit_kerja,
                status : data.status,
                status_ttd : data.status_ttd,
                tgl : data.tgl,
                tgl_validasi : data.tgl_validasi,
                tgl_ttd : data.tgl_ttd,
                tgl_agenda : data.tgl_agenda,
            };

            this.getPenerima();
        },
        emptyData : function(){
            this.list_penerima = [];
             this.fileku = null;
        },
        // ============================== TAMBAHAN =============================
            
            getPenerima: function() {
                fetch(ADD_URL+'view_penerima', {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        id: this.form.id,
                    })

                }).then(res => res.json()).then(res_data => {
                    this.list_penerima = res_data;
                    console.log(res_data);
                });
            },
            tambahPenerima : function(){
                fetch (ADD_URL+'tambah_penerima', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        id: this.form.id,
                        unit_pengirim : this.form.unit_kerja,
                        penanda_tangan_id : this.form.penanda_tangan_id,
                        pemeriksa_id : this.form.pemeriksa_id,
                        unit_penerima : this.list_unit_kerja
                    })
                }).then((res_data)=>{
                    this.alertku("success", "sukses menambah data");
                    this.getPenerima();
                });
            },
            removePenerima : function(id){
                fetch (ADD_URL+'delete_penerima', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        id: id
                    })
                }).then((res_data)=>{
                    this.alertku("success", "sukses menghapus data");
                    this.getPenerima();
                });
            },
            getUnit_kerja: function() {
                fetch(UNIT_KERJA+'view_search', {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke: this.page_first1,
                        cari: this.cari_unit_kerja,
                    })
                }).then(res => res.json()).then(res_data => {
                    console.log(res_data);
                    this.list_penerima.forEach(list_data => {
                        for (let i = 0; i < res_data.data.length; i++) {
                            if (list_data.unit_penerima == res_data.data[i].id) {
                                res_data.data.splice(i, 1); 
                            }
                        }
                    });
                    this.pilih_unit_kerja = res_data.data;
                    this.page_last1 = res_data.jml_data;

                });
            },
            emptyDataUnit_Kerja : function(){
                this.list_unit_kerja = [];
                this.pilih_unit_kerja = [];
            },

            timeSplit : function(date){
                var time = date.split('T');
                var tgl = time[0].split('-');
                return tgl[2]+"-"+tgl[1]+"-"+tgl[0]
            },
            cek_ttd : function(data){
                if (data) {
                    return 'ditandatangani'
                }else{
                    return 'proses'
                }
            },
        // ============================== TAMBAHAN =============================
        // ================== PAGINASI ====================
            alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
            },

            btn_prev: function() {
            if (this.page_first > 1) {
                this.page_first--;
            } else {
                this.page_first = 1;
            }
            this.getView();
            },

            btn_next: function() {
            if (this.page_first >= this.page_last) {
                this.page_first == this.page_last;
            } else {
                this.page_first++;
            }
                this.getView();
            },
            cari_data: function() {
                this.page_first= 1;
                this.getView();
            },

            // =============
             btn_prev1: function() {
                if (this.page_first1 > 1) {
                    this.page_first1--;
                } else {
                    this.page_first1 = 1;
                }
                this.getUnit_kerja();
            },

            btn_next1: function() {
                if (this.page_first1 >= this.page_last1) {
                    this.page_first1 == this.page_last1;
                } else {
                    this.page_first1++;
                }
                this.getUnit_kerja();
            },

            filter_unit_kerja: function() {
                this.page_first1= 1;
                this.getUnit_kerja();
            },
            // =============
        // ================== PAGINASI ====================
    },
    // =============================================================== METHODS =========================================================================

    mounted() {
        localStorage.sidemenu = 'office';
        this.getView();
        $(".pilih_unit").click(function(){
            // $("p").toggle();
            alert('bjquery')
        });
       
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;
            this.instansi_id = get_profile.profile.instansi_id;

            this.form.unit_kerja = get_profile.profile.unit_kerja;
            this.form.instansi_id = get_profile.profile.instansi_id;
    },

    };
</script>
